<template>
  <header>
    <h1>
      {{ $store.getters.pageTitle }}
      <span v-if="$store.getters.pageTitleEng">{{ $store.getters.pageTitleEng }}</span>
    </h1>
    <ul>
      <li><router-link :to="{ name: 'bracan' }"><i class="fa-solid fa-tent"></i></router-link></li>
      <li><router-link :to="{ name: 'rentaltent' }"><i class="fa-solid fa-campground"></i></router-link></li>
    </ul>
  </header>
  <main>
    <router-view/>
  </main>
  <footer>
    {{ temp }}
    <p>{{ title }} {{ currentVersion }}</p>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      title: require('../package.json').title,
      currentVersion: require('../package.json').version
    }
  },
  mounted () {
    this.$store.watch(
      (state, getters) => getters.processing,
      (newValue) => {
        if (newValue) {
          // bodyにprocessingクラスを付与
          document.body.classList.add('processing')
        } else {
          // bodyからprocessingクラスを削除
          document.body.classList.remove('processing')
        }
      }
    )
    // // ブラウザの言語を取得
    // const lang = window.navigator.language
    // // ブラウザの言語が日本語の場合
    // if (lang === 'ja') {
    //   // タイトルを日本語に設定
    //   this.$store.commit('Page/title', 'キャンプ場予約')
    // } else {
    //   // タイトルを英語に設定
    //   this.$store.commit('Page/title', 'Campsite Reservation')
    // }
  },
  methods: {
  },
  computed: {
  }
}
</script>
